<template>
    <div>
        <v-dialog v-model="adminDialog" max-width="768">
            <v-card>
                <v-card-title>
                    <span>{{  $t('new_webinar_admin')  }}</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="webinarAdminForm">
                        <v-row>
                            <v-col cols="12" lg="12">
                                <v-text-field v-model="editedAdminItem.name" :label="$t('name')" required
                                    :rules="nameRules"></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="12">
                                <v-text-field v-model="editedAdminItem.mobile" :label="$t('mobile')" required
                                    :rules="mobileRules"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="saveNewAdmin" :loading="addAdminLoading">
                        {{  $t('save')  }}
                    </v-btn>
                    <v-btn color="primary" text @click="close" :loading="addAdminLoading">
                        {{  $t('close')  }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteAdminDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large right color="primary" > mdi-comment-question-outline</v-icon>
                    <span>{{  $t('webinar_delete_admin_dialog_text')  }}</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="deleteAdmin">{{  $t('yes')  }}</v-btn>
                    <v-btn color="primary" text @click="deleteClose">{{  $t('no')  }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-data-table :headers="tableHeaders" :items="adminsList" :loading="loading" class="elevation-1"
            :server-items-length="totalRows" :options.sync="options" :footer-props="{ showFirstLastPage: true}"
                :hide-default-footer="true" disable-sort item-key="admin_id">
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>{{  webinarName  }}</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn text color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="adminDialog = true" v-show="hasPermission('webinar_plus_admin_add')">
                                    <v-icon left medium>mdi-account-plus</v-icon>
                                </v-btn>

                            </template>
                            <span>
                                {{  $t('new_webinar_admin')  }}
                            </span>
                        </v-tooltip>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on"
                            :disabled="!hasPermission('webinar_plus_admin_delete')">
                                <v-icon medium @click="showDeleteDialog(item)">mdi-account-minus</v-icon>
                            </v-btn>
                        </template>
                        <span>{{  $t('remove_admin')  }}</span>
                    </v-tooltip>

                </template>


            </v-data-table>
        </v-card>
    </div>
</template>
<script>
import axios from 'axios';
import permissions from '../mixins/permissions';
export default {
    name: "WebinarAdmins",
    mixins:[permissions],
    props: ["company", "webinarName"],
    data() {
        return {
            tableHeaders: [
                { text: this.$t("name"), value: "name" },
                { text: this.$t("mobile"), value: "mobile" },
                { text: this.$t("email"), value: "email" },
                { text: this.$t("action"), value: "actions", sortable: false },

            ],
            adminsList: [],
            defaultAdminItem: { mobile: '', name: '' },
            editedAdminItem: { mobile: '', name: '' },
            deleteAdminDialog: false,
            deleteAdminItem: null,
            itemPerPage: 10,
            pageNumber: 1,
            plans: [],
            loading: false,
            options: {},
            totalRows: 0,
            startRow: 0,
            endRow: 10,
            adminDialog: false,
            editedIndex: -1,
            nameRules: [v => !!v || this.$t("name_required")],
            mobileRules: [
                v => !!v || this.$t("mobile_required"),
                v => Number.isInteger(Number(v) || this.$t("mobile_invalid"))
            ],
            addAdminLoading:false
        };
    },
    watch: {
        options: {
            handler() {
                this.getAdminsList();
            },
            deep: true,
        }
    },
    methods: {
        getAdminsList() {
            const { page, itemsPerPage } = this.options;

            let _startRow = itemsPerPage * page - itemsPerPage;
            let _endRow = itemsPerPage * page - 1;
            if (_endRow < 0)
                _endRow = this.totalServers;
            const payload = { _startRow: _startRow, _endRow: _endRow };
            if (this.company) {
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/"+this.company+"/admins",
                    method: "GET",
                    headers: {
                        // 'Content-Type': 'multipart/form-data',
                        Authorization: this.$store.get("login/token"),
                    },
                    data: payload,
                }).then(response => {
                    console.log("data", response);
                    const data = response.data.response.data;
                    this.adminsList = data;
                    this.totalRows = data.length;
                    this.loading = false;
                });
            }
        },
        validateWebinarAdminForm() {
            this.$refs.webinarAdminForm.validate();
        },
        resetValidateWebinarAdminForm() {
            // this.$refs.webinarForm.resetValidation();
        },
        showDeleteDialog(item){
            this.deleteAdminItem = item
            this.deleteAdminDialog = true; 
        },
        deleteAdmin() {
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/"+this.company+"/admins/"+this.deleteAdminItem.id,
                    method: "DELETE",
                    headers: {
                        Authorization: this.$store.get("login/token"),
                    },
                }).then(response => {
                    console.log(response.data);
                    this.deleteClose();
                    this.getAdminsList();
                    this.$toasted.success(this.$t("webinar_admin_deleted_successfully"));
                }).catch(error => {
                    console.log(error.response);
                    this.$toasted.error(this.$t("webinar_admin_error_deleting"));
                });

         },
        close() {
            this.adminDialog = false;
            this.$nextTick(() => {
                this.editedAdminItem = Object.assign({}, this.defaultAdminItem);
                this.editedIndex = -1;
                this.resetValidateWebinarAdminForm();
            });
        },
        deleteClose() {
            this.deleteAdminDialog = false;
            this.$nextTick(() => {
                this.deleteAdminItem = null;
            });
        },
        saveNewAdmin() {
            if (!this.$refs.webinarAdminForm.validate()) {
                this.$toasted.error(this.$t("fill_the_form"), { icon: { name: "alert-circle" } });
            }
            else {
                this.addAdminLoading=true;
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/"+this.company+"/admins",
                    method: "POST",
                    headers: {
                        Authorization: this.$store.get("login/token"),
                    },
                    data: this.editedAdminItem,
                }).then(response => {
                    console.log(response.data);
                    this.close();
                    this.getAdminsList();
                    this.$toasted.success(this.$t("webinar_admin_added_successfully"));
                }).catch(error => {
                    console.log(error.response);
                    this.$toasted.error(this.$t("webinar_admin_error_adding"));
                }).finally(()=>{
                    this.addAdminLoading=false;
                });
            }
        }
    },
    mounted() {
        this.getAdminsList();
    }
}
</script>